export const environment = {
    production: true,
    featurevisorDatafileUrl:
        "/featurevisor/production/featurevisor-tag-all.json",
    integrations: {
        airplaneManager:
            "https://corp.airplanemanager.com/app/externalcredentials?vendor=PFM&token=:token:",
    },
    sentryEnvironmentName: "production",
};
